export const MODULE_PREFIX = 'map';
